export const config = {
  title: "ATLANTIC FLORIDA PROPERTIES | Smith Laurent – Trusted Real Estate Services in Wellington, FL",
  meta: {
    description:
      "ATLANTIC FLORIDA PROPERTIES | Smith Laurent provides expert real estate services in Wellington, FL. Whether you're buying or selling, our team ensures a seamless experience with personalized service.",
    keywords: [
      "Wellington FL real estate",
      "Smith Laurent Realty",
      "Atlantic Florida Properties",
      "buy home Wellington FL",
      "sell home Wellington FL"
    ],
    author: "ATLANTIC FLORIDA PROPERTIES | Smith Laurent",
    canonicalUrl: "https://www.smithlaurentrealty.com/",
  },
  sections: {
    header: {
      businessName: "ATLANTIC FLORIDA PROPERTIES | Smith Laurent",
    },
    sectionB: {
      heroTitle: "Smith Laurent Realty",
      heroSubtitle: "Your Real Estate Partner in Wellington, FL",
      learnAboutText: "Explore Listings",
      phoneNumber: "7862665483",
      phoneLabel: "(786) 266-5483",
      heroBackgroundImage:
      "https://media.istockphoto.com/id/2164822692/photo/suburban-sprawl.jpg?s=612x612&w=0&k=20&c=Z1eiTgQPjSVSpTwcNr7gcvIcBX8lMjCHeV_iDxqWONA=",
      cardData: [
        {
          title: "Residential Sales",
          description: "Buy or sell your home with confidence through our local expertise.",
        },
        {
          title: "Investment Properties",
          description: "Explore opportunities in Florida's competitive property market.",
        },
        {
          title: "Personalized Support",
          description: "We guide you through every step of the real estate journey.",
        },
      ],
      description:
        "Smith Laurent and the Atlantic Florida Properties team specialize in real estate solutions tailored to your needs in Wellington, FL. Contact us today for a reliable partner in your home journey.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Our commitment to clients ensures professionalism, attention to detail, and a results-driven real estate experience.",
      cards: [
        {
          title: "Buying Assistance",
          description: "Navigate the home-buying process with our expert support.",
          imageSrc: "https://media.istockphoto.com/id/1497684257/photo/real-estate-agent-explain-house-plans-to-view-house-plans-and-sales-contracts-house-purchase.jpg?s=612x612&w=0&k=20&c=CUzac2HRc9FQW2at2fbDxVfYKRdNYvg6CcNl8D9IHAM=",
          imageAlt: "Home buying",
        },
        {
          title: "Home Selling",
          description: "Maximize your home's value with strategic marketing.",
          imageSrc: "https://media.istockphoto.com/id/827615404/photo/paper-house-under-a-magnifying-lens.jpg?s=612x612&w=0&k=20&c=97KzqjE4gKtU5P0Bs3xFwbOLzNJtwWAnYPUZO1ZaaQI=",
          imageAlt: "Home selling",
        },
        {
          title: "Market Insights",
          description: "Stay ahead with local market trends and pricing guidance.",
          imageSrc: "https://media.istockphoto.com/id/2197655235/photo/close-up-of-three-people-looking-at-financial-data-with-graphs-and-charts.jpg?s=612x612&w=0&k=20&c=rOX0dS9sbA5EaYkcj-UdjeboXoopcu4-dy6qp0XJy_c=",
          imageAlt: "Real estate data",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Local Real Estate Expertise",
        "Trusted REALTOR®",
        "Tailored Solutions",
        "Responsive Communication",
        "Multilingual Support"
      ],
    },
    sectionD: {
      aboutTitle: "About Smith Laurent Realty",
      aboutImage: {
        src: "https://u.realgeeks.media/smithlaurentrealty/8820f2de7466-unnamed__1_.jpg",
        alt: "Smith Laurent",
      },
      aboutText: [
        "Smith Laurent is a dedicated real estate professional affiliated with Atlantic Florida Properties. Based in Wellington, FL, Smith brings years of experience and local knowledge to every client relationship.",
        "Whether you're buying your dream home or investing in Florida real estate, Smith is here to provide exceptional service and expert guidance."
      ],
    },
    sectionE: {
      profileImage: "https://t2.realgeeks.media/thumbnail/k31PrEOEQzqmx40hGUz7l3OYLqk=/fit-in/400x86/filters:format(png)/u.realgeeks.media/smithlaurentrealty/152578e328bf-afp.logo2__2_.jpg",
      profileAlt: "Smith Laurent",
      businessName: "ATLANTIC FLORIDA PROPERTIES | Smith Laurent",
      contact: {
        phone: "7862665483",
        phoneLabel: "(786) 266-5483",
        email: "smithlaurentllc@gmail.com",
        website: "https://www.smithlaurentrealty.com/",
        address: "8461 Lake Worth Rd Suite 203, Wellington, FL 33467, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "8461 Lake Worth Rd Suite 203, Wellington, FL 33467, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3586.479234184333!2d-80.17605152496037!3d26.616913877509624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d8d5663d2c7f4b%3A0xf847005ebf420189!2s8461%20Lake%20Worth%20Rd%20Suite%20203%2C%20Wellington%2C%20FL%2033467%2C%20USA!5e0!3m2!1sen!2sph!4v1693725412003",
    },    
  },
};

export default config;
